import "./App.css";
import "simplebar-react/dist/simplebar.min.css";
import "./config/sentry";
import React from "react";
import UpdatesModal from "./components/common/updates-modal";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./config/query.ts";
import router from "./router";
import { Backdrop, theme, Snackbar } from "@dippi/ui";
import { useUser } from "./context/user.ts";
import { ThemeProvider } from "@mui/material";
import useDocumentTitle from "./hooks/misc/useDocumentTitle.ts";
import useUpdates from "./hooks/misc/useUpdates.ts";
import useLoadApp from "./hooks/auth/useLoadApp.ts";

const App: React.FC = () => {
    const globalLoading = useUser(state => state.globalLoading);
    const isAppLoaded = useUser(state => state.isAppLoaded);

    useLoadApp();
    useDocumentTitle();
    useUpdates();

    return (
        <ThemeProvider theme={theme}>
            {!isAppLoaded ? (
                <Backdrop loading={true} />
            ) : (
                <QueryClientProvider client={queryClient}>
                    <RouterProvider router={router} />
                    <Backdrop loading={globalLoading} />
                    <UpdatesModal />
                    <Snackbar />
                </QueryClientProvider>
            )}
        </ThemeProvider>
    );
};

export default App;
